<script>
	import { onMount, setContext } from "svelte";
	import { writable, get } from "svelte/store";
	import clamp from "../../Helpers/Misc/clamp";
	import UIHelper from "../../Helpers/UIHelper";

	import "./FlyoutMenu.scss";

	export let visible = false;
	export let resizable = true;
	export let side = "left";

	let menu;
	let resizeBar;
	let dragging = false;
	let hiddenStyle = "";
	let updateStyle = () => {
		if (menu) {
			hiddenStyle = "margin-" + side + ": -" + parseInt((menu.style.width)+3) + "px;";
		}
	}

	onMount(()=>{
		let onMouseDown = (e) => {
			if (!resizable) { return; }

			e.preventDefault();
			dragging = true;
			document.addEventListener("mousemove", onMouseMove);
			document.addEventListener("mouseup", onMouseUp);
		};
		let onMouseMove = (e) => {
			if (!resizable) { return; }

			if (dragging) {
				const size = (side === "left")
					? e.pageX
					: window.innerWidth - e.pageX;
				menu.style.width = size + "px";
				updateStyle();
			}
		};
		let onMouseUp = (e) => {
			if (!resizable) { return; }

			dragging = false;
			document.removeEventListener("mousemove", onMouseMove);
			document.removeEventListener("mouseup", onMouseUp);
		};
		if (resizable) {
			resizeBar.addEventListener("mousedown", onMouseDown);
		}

		// Note: tried to make it auto size the bar based on resize events, no work because the menu can container resizable elements (e.g. tables) inside it.
		let onScroll = () => {
			let newTop = clamp(menu.scrollTop, 0, window.innerHeight);
			resizeBar.style.top = newTop + "px";

			// ^AG: Safari hacks to fix calc(100%)? height not working.
			menu.style.height = (window.innerHeight - UIHelper.getBannerHeight()) + "px";
		}
		menu.addEventListener("scroll", onScroll);
		window.addEventListener("resize", onScroll);
		onScroll();
	});
</script>

<div bind:this={menu} class="menu" class:right={side === "right"} class:hidden={!visible} style={((!visible)?hiddenStyle:"")}>
	<div bind:this={resizeBar} class="resize-bar" class:right={side === "right"}></div>
	<slot/>

</div>
